<template>
  <div class="containerV2">
    <div class="collection-toolbar">
      <div class="collection-toolbar__meta">
        <p>{{ productCount }} Products</p>
      </div>
      <div class="collection-toolbar__actions">
        <IconButton
          :icon-position="mq.mdPlus ? 'right' : 'left'"
          icon="filter"
          form="transparent"
          class="filter-btn"
          @click="setIsFiltersOpen(true)"
        >
          Filters <template v-if="!mq.mdPlus">& Sort</template>
        </IconButton>
        <DropdownButton
          v-if="mq.mdPlus"
          :options="sortOptions"
          :active-option="activeSort.value"
          @change="handleSortChange"
        >
          Sort
        </DropdownButton>
        <ToggleButton
          v-if="false"
          :icons="['hanger', 'person']"
          class="toggle-btn"
          @toggle="handleToggleChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "@/components/IconButton.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import DropdownButton from "@/components/DropdownButton.vue";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "CollectionToolbar",
  components: {
    IconButton,
    ToggleButton,
    DropdownButton,
  },
  inject: ["mq"],
  computed: {
    ...mapState("collection", ["sortOptions"]),
    ...mapGetters("collection", ["productCount", "activeSort"]),
  },
  methods: {
    ...mapActions("collection", [
      "fetchCollection",
      "setSort",
      "setIsFiltersOpen",
      "setImageSequenceType",
    ]),
    async handleSortChange(value) {
      const reverse = value.includes("_DESC");
      const strippedValue = value.replace("_ASC", "").replace("_DESC", "");

      this.setSort({ value: strippedValue, reverse });
    },
    handleToggleChange(value) {
      this.setImageSequenceType(value ? "campaign" : "curated");
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-toolbar {
  display: block;
  padding: 12px 0;

  @include respond-above(md) {
    justify-content: space-between;
    align-items: center;
    display: flex;
  }

  &__meta {
    display: none;

    @include respond-above(md) {
      display: block;
    }

    p {
      @include utility-label(12px);
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;

    .filter-btn {
      order: 1;

      @include respond-above(md) {
        order: 0;
      }
    }

    .toggle-btn {
      order: 0;

      @include respond-above(md) {
        margin-left: 20px;
        order: 1;
      }
    }

    :deep(.icon-button) {
      margin-left: 20px;
      @include utility-label(12px);
    }
  }
}
</style>
